import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";


import {
  postLogin

} from "../../../helpers/backend_helper";



function* loginUser({ payload: { user, history } }) {
  try {
      console.log("user saga", user);
      const response = yield call(postLogin, {
          userName:  user.userName,
          password: user.password
      });
       const data = JSON.stringify(response)
      localStorage.setItem("authUser", data);
      
        const dparse = JSON.parse(data);
        
        //localStorage.setItem("token",dparse.resultData.bearerToken);
        //localStorage.setItem("refreshToken",dparse.resultData.refreshToken);
        localStorage.setItem("userId",dparse.resultData.uId);
        localStorage.setItem("userName",dparse.resultData.userName);
        localStorage.setItem("userRole",dparse.resultData.userRole);
      yield put(loginSuccess(response));
      history('/dashboard');
  } catch (error) {
   
     if(!error.response.result){
    yield put(apiError('Invalid User'))
  }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
    yield put(logoutUserSuccess());

    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
